import gsap from 'gsap';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';
import Heading from '../../sharedComponents/Heading/Heading';
import './HomePage.scss';
import { useEffect } from 'react';

gsap.registerPlugin(ScrambleTextPlugin);

function HomePage() {
  useEffect(() => {
    const tl = gsap.timeline({
      id: "text-scramble",
      defaults: { ease: "none" }
    });

    const cursorTl = gsap.timeline({ repeat: -1 });

    gsap.set("#scramble-text-original", {
      opacity: 0
    });

    cursorTl
      .to("#scramble-cursor", {
        opacity: 0,
        duration: 0.5,
        ease: "none",
        delay: 0.2
      })
      .to("#scramble-cursor", {
        opacity: 1,
        duration: 0.5,
        ease: "none",
        delay: 0.2
      });

    tl.to("#scramble-text-1", {
      scrambleText: {
        text: "Pioneering AI for a Smarter Future.",
        chars: "lowerCase"
      },
      duration: 2
    })
      .add(cursorTl);
  }, [])

  return (
    <div id='alpha-perceptron-homepage' className='alpha-perceptron-homepage'>
      <div className='alpha-perceptron-homepage__text-container'>
        <div className="text-scramble__content">
          <p className='scramble-text' id="scramble-text-original">
            Pioneering AI for a Smarter Future
          </p>
          <p className="text-scramble__text" aria-hidden="true">
            <span></span>
            <span className='scramble-text' id="scramble-text-1"></span>

            <img className='scramble-cursor' id="scramble-cursor" src="https://assets.codepen.io/16327/scramble-cursor.png" alt="" />
          </p>
        </div>

        <br />
        <Heading size='h6' theme='dark' type='secondary'>
          Redefining intelligence with cutting-edge AI advancements in cognition and automation.
        </Heading>
      </div>
    </div>
  );
}

export default HomePage;

